import { useEffect, useState } from "preact/hooks";
import { formatTime, parseTime, type TimeFormat } from "../tz/civil";

interface Props {
  hour: number;
  minute: number;
  fmt: TimeFormat;
  onChange: (hour: number, minute: number) => void;
}

export function TimeInput({ hour, minute, fmt, onChange }: Props) {
  const display = formatTime({ year: 0, month: 1, day: 1, hour, minute, second: 0, weekday: 0 }, fmt);
  const [text, setText] = useState(display);
  const [bad, setBad] = useState(false);
  useEffect(() => {
    setText(display);
    setBad(false);
  }, [display]);

  const commit = () => {
    const t = parseTime(text);
    if (t) {
      setBad(false);
      onChange(t.hour, t.minute);
      setText(formatTime({ year: 0, month: 1, day: 1, hour: t.hour, minute: t.minute, second: 0, weekday: 0 }, fmt));
    } else setBad(true);
  };

  return (
    <div class="time-input">
      <input
        type="text"
        class={bad ? "invalid" : ""}
        aria-label="Clock time"
        value={text}
        size={9}
        onInput={(e) => setText((e.target as HTMLInputElement).value)}
        onBlur={commit}
        onKeyDown={(e) => {
          if (e.key === "Enter") commit();
        }}
      />
      <input
        type="range"
        aria-label="Clock time slider"
        min={0}
        max={1439}
        step={5}
        value={hour * 60 + minute}
        onInput={(e) => {
          const v = +(e.target as HTMLInputElement).value;
          onChange(Math.floor(v / 60), v % 60);
        }}
      />
    </div>
  );
}
